module.exports = __webpack_public_path__ + "img/benefits-of-chiropractic-care.9bcbc328.jpg";